import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useNavigate, useSearchParams} from 'react-router-dom'
import {useFormik} from 'formik'
import {PasswordMeterComponent} from '../../../../_metronic/assets/ts/components'
import {FleksupService} from '../../../services/FleksupService'

const initialValues = {
  newPassword: '',
  confirmPassword: '',
}

const resetPasswordSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(8, 'En az 8 karakter giriniz.')
    .max(16, 'En fazla 16 karakter girilebilir.')
    .required('Şifre zorunludur.'),
  confirmPassword: Yup.string()
    .required('Yeni Şifre (Tekrar) alanı zorunludur.')
    .when('newPassword', {
      is: (val: string) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf([Yup.ref('newPassword')], 'Yeni şifre alanları eşleşmiyor.'),
    }),
})

export function ResetPassword() {
  const [status, setStatus] = useState<any>()
  const [rowId, setRowId] = useState()
  const [loading, setLoading] = useState(true)
  const [btnLoading, setBtnLoading] = useState(false)
  const [searchParams] = useSearchParams()
  let navigate = useNavigate()
  const formik = useFormik({
    initialValues,
    validationSchema: resetPasswordSchema,
    onSubmit: (values) => {
      setBtnLoading(true)
      FleksupService.resetPassword(rowId, values.newPassword, values.confirmPassword)
        .then((res) => {
          if (res.data.successful) {
            setStatus('Şifreniz başarıyla değiştirildi. Giriş ekranına yönlendiriliyorsunuz....')
            setTimeout(() => {
              navigate('/account/login')
            }, 3000)
          }
        })
        .catch((e) => {
          setBtnLoading(false)
        })
    },
  })

  useEffect(() => {
    const paramRowId: any = searchParams.get('rowid')
    if (paramRowId) {
      FleksupService.checkRowId(paramRowId)
        .then((res) => {
          if (res.data.successful) {
            setLoading(false)
            setRowId(paramRowId)
            PasswordMeterComponent.bootstrap()
          } else {
            navigate('/account/login')
          }
        })
        .catch((e) => {
          navigate('/account/login')
        })
    } else {
      navigate('/account/login')
    }
  }, [navigate, searchParams])

  return loading ? null : (
    <>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          <h1 className='text-dark mb-3'>Yeni şifrenizi belirleyiniz.</h1>
        </div>
        {status && (
          <div className={`mb-lg-15 alert alert-success`}>
            <div className='alert-text font-weight-bold'>{status}</div>
          </div>
        )}
        <div className='mb-5 fv-row' data-kt-password-meter='true'>
          <div className='mb-1'>
            <label className='form-label fw-bolder text-dark fs-6'>Yeni Şifre</label>
            <div className='position-relative mb-3'>
              <input
                type='password'
                placeholder='Yeni Şifre'
                autoComplete='off'
                {...formik.getFieldProps('newPassword')}
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {
                    'is-invalid': formik.touched.newPassword && formik.errors.newPassword,
                  },
                  {
                    'is-valid': formik.touched.newPassword && !formik.errors.newPassword,
                  }
                )}
              />
              {formik.touched.newPassword && formik.errors.newPassword && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.newPassword}</span>
                  </div>
                </div>
              )}
            </div>
            <div
              className='d-flex align-items-center mb-3'
              data-kt-password-meter-control='highlight'
            >
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
            </div>
          </div>
          <div className='text-muted'>
            Harf, sayı ve simge karışımıyla 8 veya daha fazla karakter kullanın.
          </div>
        </div>
        <div className='fv-row mb-5'>
          <label className='form-label fw-bolder text-dark fs-6'>Yeni Şifre (Tekrar)</label>
          <input
            type='password'
            placeholder='Yeni Şifre (Tekrar)'
            autoComplete='off'
            {...formik.getFieldProps('confirmPassword')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {
                'is-invalid': formik.touched.confirmPassword && formik.errors.confirmPassword,
              },
              {
                'is-valid': formik.touched.confirmPassword && !formik.errors.confirmPassword,
              }
            )}
          />
          {formik.touched.confirmPassword && formik.errors.confirmPassword && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.confirmPassword}</span>
              </div>
            </div>
          )}
        </div>
        <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
          <button
            type='submit'
            id='kt_password_reset_submit'
            className='btn btn-lg btn-primary fw-bolder me-4 w-100'
            disabled={btnLoading}
          >
            <span className='indicator-label'>Şifremi Sıfırla</span>
            {btnLoading && (
              <span className='indicator-progress'>
                Lütfen Bekleyin...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        {/* end::Form group */}
      </form>
    </>
  )
}
